import { Entypo } from '@expo/vector-icons';
import styled from 'styled-components/native';

export default styled(Entypo).attrs({ name: 'chevron-thin-down', color: '#fff', size: 10 })`
  margin-left: 5px;
`;
